<template>
  <div class="account">
    <div class="title">{{ $tr('vacancy.settings.talentq.project-settings') }}</div>
    <slot/>
  </div>
</template>

<script>
  export default {
    name: "project-view"
  }
</script>
<style scoped lang="scss">
  .account {
    margin: 20px 0;
    .title {
      margin: 10px 0;
      font-weight: 500;
      font-size: 18px;
    }
  }
</style>